import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-log-out',
  templateUrl: './log-out.component.html',
  styleUrls: ['./log-out.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogOutIconComponent {}
